import React from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';

const EventDatePicker = ({ eventDate, onChange, error, ...remainingProps }) => {
  const { KeyboardDatePicker } = useUiContext();

  return (
    <KeyboardDatePicker
      fullWidth
      clearable
      name="eventDate"
      inputVariant="outlined"
      label="Event Date"
      format="MM/dd/yyyy"
      value={eventDate}
      onChange={onChange}
      error={error}
      minDate={new Date()}
      KeyboardButtonProps={{
        'aria-label': 'change date',
      }}
      {...remainingProps}
    />
  );
};

EventDatePicker.propTypes = {
  eventDate: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
};
export default EventDatePicker;
